/* eslint-disable camelcase, no-global-assign */

if (typeof window !== "undefined" && window.__COURSES_DASHBOARD_PUBLIC_PATH__) {
  // eslint-disable-next-line no-undef
  __webpack_public_path__ = window.__COURSES_DASHBOARD_PUBLIC_PATH__;
}
